import axios from 'axios';
import API_URL from '../../config/ApiUrl';
import { makeAutoObservable } from 'mobx';
import moment from 'moment';
import { displayFormats } from '../../config/Global';

export default class DashboardStore {
	initialFormData = {
		type: 'cm',
	};
	list_data = null;
	agGrid = null;
	per_page = 50;

	constructor() {
		makeAutoObservable(this);
	}

	setupGrid = (params) => {
		this.agGrid = params;
	};

	setPageSize = (page = this.per_page) => {
		this.per_page = page;
		if (this.agGrid) {
			this.agGrid.api.paginationSetPageSize(Number(page));
		}
	};

	// CM Symbol list
	getCMSymbolList = async () => {
		try {
			const data = await axios.get(API_URL.DASHBOARD.CMSYMBOLLIST);
			this.cmSymbolList = data.data;
			return data.data;
		} catch {}
	};

	// CM Table Data
	getCMSymbolDataList = async (req) => {
		// this.agGrid.api.showLoadingOverlay()
		try {
			const data = await axios.post(
				API_URL.DASHBOARD.CMHISTORICALDATALIST,
				req
			);
			this.list_data = data.data;
			return data;
		} catch {}
	};

	// Indices Symbol list
	getIndicesSymbolList = async () => {
		try {
			const data = await axios.get(API_URL.DASHBOARD.INDICESLIST);
			this.indicesSymbolList = data.data;
			return data.data;
		} catch {}
	};

	// indices Table Data
	getIndicesSymbolDataList = async (req) => {
		// this.agGrid.api.showLoadingOverlay()
		try {
			const data = await axios.post(
				API_URL.DASHBOARD.INDICESDATALIST,
				req
			);
			this.list_data = data.data;
			return data;
		} catch {}
	};

	// For FO - Instrument
	getFOInstrumentList = async () => {
		try {
			const data = await axios.get(API_URL.DASHBOARD.FOINSTRUMENT);
			this.FOInstrumentList = data.data;
			return data.data;
		} catch (e) {
			return Promise.reject(e);
		}
	};

	// For FO - Symbol list
	getFOSymbolList = async (payload) => {
		try {
			const data = await axios.post(API_URL.DASHBOARD.FOSYMBOL, payload);
			this.FOSymbolList = data.data;
			return data.data;
		} catch {}
	};

	// For FO - Option Type List
	getFOOptionTypeList = async () => {
		try {
			const data = await axios.get(API_URL.DASHBOARD.FOALLOPTIONTYPE);
			this.FOOptionTypeList = data.data;
			return data.data;
		} catch {}
	};

	// For FO - Option Expiry List
	getFOExDateList = async (payload) => {
		try {
			const data = await axios.post(
				API_URL.DASHBOARD.FOEXPIREDATE,
				payload
			);
			data.data.map((_x) => {
				_x.name = moment(_x.value).format(displayFormats.DATE_FORMAT);
				return _x;
			});
			this.FOExpiryDates = data.data;
			return data.data;
		} catch {}
	};

	// For FO - Option Strike price list
	getFOStrikePriceList = async (payload) => {
		try {
			const data = await axios.post(
				API_URL.DASHBOARD.FOSTRIKEPR,
				payload
			);
			this.FOStrikePriceList = data.data;
			return data.data;
		} catch {}
	};

	// FO Table Data
	getFOSymbolDataList = async (payload) => {
		try {
			const data = await axios.post(
				API_URL.DASHBOARD.FOGETLISTDATA,
				payload
			);
			this.list_data = data.data;
			return data;
		} catch {}
	};
}
